import { FormService } from './../services/form.service';
import { ResponseService } from './../services/response.service';
import { PhoneService } from './../services/phone.service';
import { CustomDSValidators } from './../shared/validators/custom-validators';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BreadcrumbsService } from './../services/breadcrumbs.service';
import { NotificationsService } from 'angular2-notifications';
import { FormControl, FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Response } from '@angular/http';
import { ApiService } from './../services/api.service';
import { AuthService } from './../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { CustomFormsModule, CustomValidators } from 'ng2-validation';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Component({
  moduleId: module.id,
  selector: 'app-main',
  templateUrl: './register.component.html',
})
export class RegisterComponent implements OnInit {

  public passwordHint: boolean = false;
  public passwordConfirmHint: boolean = false;
  public phoneHint: boolean = false;

  API_URL = `${environment.api_url}`;

  public phoneCodes;

  loading: Boolean = false;
  submitted: Boolean = false;

  registerForm: FormGroup;

  emailError: Boolean = false;
  emailErrorMessage: string = '';

  subscriber: any;
  isAuth: Boolean;

  rodoInfo: any;

  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    private router: Router,
    private notificationService: NotificationsService,
    private breadcrumbsService: BreadcrumbsService,
    private translateService: TranslateService,
    private phoneService: PhoneService,
    private responseService: ResponseService,
    private formService: FormService,
    private domSanitizer: DomSanitizer
  ) {
    let controls = {
      email: new FormControl(''),
      email_confirmation: new FormControl(''),
      password: new FormControl('', ),
      password_confirmation: new FormControl(''),
      cc_phone: new FormControl('PL'),
      phone: new FormControl(''),
      accept_terms: new FormControl(false),
      accept_rodo: new FormControl(false)
    };

    let validators = {
      email: [Validators.required, CustomValidators.email],
      email_confirmation: [Validators.required, CustomValidators.email, CustomValidators.equalTo(controls.email)],
      password: [Validators.required, Validators.minLength(8)],
      password_confirmation: [Validators.required, Validators.minLength(8), CustomValidators.equalTo(controls.password)],
      cc_phone: [Validators.required],
      phone: [Validators.required, CustomDSValidators.internationalPhoneNumber(controls.cc_phone)],
      accept_terms: [Validators.required, Validators.pattern('true')],
      accept_rodo: [Validators.required, Validators.pattern('true')]
    };

    this.registerForm = this.formService.buildForm(controls, validators);
  }

  ngOnInit() {
    this.apiService.getCSRFToken();
    this.phoneCodes = this.phoneService.getCountryCodes();
    this.registerForm.controls['cc_phone'].setValue('PL');
  }

  public appendRodo() {
    this.rodoInfo = this.domSanitizer.bypassSecurityTrustHtml('<object style="width:100%;height:100%" type="application/pdf" '+ 
      'data="' + this.API_URL + '/rodo/information_obligation?mode=view">' +
      '<p>Obowiązek informacyjny nie możę zostać otwarty, proszę spróbować ponownie za chwilę</p>' +
      '<a href="' + this.API_URL + '/rodo/information_obligation" target="_rodo" title="Obowiązek informacyjny PDF">Pobierz plik PDF</a> ' +
      '</object>');
  }

  public register() {
    this.loading = true;
    this.submitted = true;

    if (this.registerForm.valid) {
      this.apiService.post('/register', this.registerForm.value)
        .subscribe(
          (response) => {
            this.loading = false;
            this.responseService.success(true, response);
            // if (this.authService.redirectUrl !== '/checkout/summary' && this.authService.redirectUrl !== '/company/select') {
            //   this.authService.redirectUrl = '/login';
            // }
            this.router.navigateByUrl('/login');
          },
          (error) => {
            this.loading = false;
            this.responseService.error(error, this.registerForm);
          }
        );
    } else {
      this.loading = false;
    }
  }

  validateField(fieldName) {
    this.registerForm.controls[fieldName].updateValueAndValidity();
  }

  openTermsModal(modal: any): void {
    modal.open();
    //console.log(modal);
    this.registerForm.controls['accept_terms'].setValue(!this.registerForm.controls['accept_terms'].value);
  }
}



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts